import { isStringWrapped } from '@/modules/common/utils/string'
import { Layout } from '@/types/layouts'
import { CAST_PROPERTY_BOX_MARKER } from '../types'
import { LayoutBox, LayoutBoxType } from '@/types/layouts'
import { AssetType } from '@/types/assets'
import { KisweSelectOption } from '@/modules/kisweui/types'

export const BOX_MIN_WIDTH = 10
export const BOX_MAX_WIDTH = 1920

export const BOX_MIN_HEIGHT = 10
export const BOX_MAX_HEIGHT = 1080

export const hasCastPropertyBoxes = (layout: Layout): boolean => {
  return Object.values(layout.boxes).some((box) => isStringWrapped(box.name.toLowerCase(), CAST_PROPERTY_BOX_MARKER))
}

export const BOX_TYPES: KisweSelectOption[]  = [
  { label: 'Video', value: AssetType.Video },
  { label: 'Image', value: AssetType.Graphic },
  { label: 'Text', value: AssetType.SimpleCG }
]

export const getDefaultBoxInstance = (
  boxId: string,
  name: string,
  zIndex: number
): LayoutBox => {
  return new LayoutBox({
    id: boxId,
    name: name,
    stretchContent: true,
    stretchVertical: true,
    type: LayoutBoxType.BOX,
    types: [AssetType.Graphic],
    zindex: zIndex
  })
}



